
// import Vue from 'vue';
// import Vuex from 'vuex';

import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import { isEmpty } from 'lodash';

export default {
  namespaced: true,
  state: {
    enums: {},
    loaded: false,
  },
  mutations: {
    ENUMS(state, newEnums) {
      state.enums = newEnums;
      localStorage.setItem('enums', JSON.stringify(newEnums));
    },
    LOADED(state, newValue) {
      state.loaded = newValue;
    },
  },
  getters: {
    enums: state => state.enums,
    loaded: state => state.loaded,
  },
  actions: {
    initialiseStore(context, promise) {
      if (!isEmpty(localStorage.getItem('enums'))) {
        try {
          context.commit('ENUMS', JSON.parse(localStorage.getItem('enums')));
          context.commit('LOADED', true);
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('Failed to load state from storage');
        }
      }

      promise
        .then((response) => {
          context.commit('ENUMS', response.data.data);
          context.commit('LOADED', true);
          localStorage.setItem('enums', JSON.stringify(response.data.data));
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/Enums.js